import { render, staticRenderFns } from "./006_BetonsarkophagRost.vue?vue&type=template&id=4d810eaa&scoped=true&"
import script from "./006_BetonsarkophagRost.vue?vue&type=script&lang=js&"
export * from "./006_BetonsarkophagRost.vue?vue&type=script&lang=js&"
import style0 from "./006_BetonsarkophagRost.vue?vue&type=style&index=0&id=4d810eaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d810eaa",
  null
  
)

export default component.exports